import { httpRequest } from "@services/http";
import { SpendAccount } from "@models/spendaccount.model";
import { SpendAccountSerializer } from "@models/serializers/spendAccountSerializer";
import { SpendAccountPayload } from "./cmdCreateSpendAccount";

export class CommandUpdateSpendAccount {
  async run(contractId: number, payload: SpendAccountPayload): Promise<SpendAccount> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/spend-account/`;
    const response = await httpRequest<any>(url, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return SpendAccountSerializer.fromJson(response);
  }
}
